import { render, staticRenderFns } from "./DisplayItems.vue?vue&type=template&id=6244d8a4&scoped=true"
import script from "./DisplayItems.vue?vue&type=script&lang=js"
export * from "./DisplayItems.vue?vue&type=script&lang=js"
import style0 from "./DisplayItems.vue?vue&type=style&index=0&id=6244d8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6244d8a4",
  null
  
)

export default component.exports